import React, { type JSX } from "react";
import SVG from "react-inlinesvg";
import { ChatLink } from "tsi-common-react/src/components/ChatLink/index";
import { RichText } from "tsi-common-react/src/components/RichText/index";
import { useAppSelector } from "tsi-common-react/src/store/reducers";
import { usePageSetting } from "tsi-common-react/src/utils/settings";
import { usePageURL } from "tsi-common-react/src/utils/urls";
import { jt, t } from "ttag";

import iconSpeechBubblesTalk from "../../../assets/svg/speech-bubbles-talk.svg";

export const CheckoutSidebarContent = (): React.ReactNode => {
    const basketId = useAppSelector(
        (state) => state.checkout.data.basket?.encoded_basket_id,
    );
    const contactURL = usePageURL("contact_us_form");
    const homeURL = usePageURL("home");
    const enableCheckoutSidebarQuestionsBlock = usePageSetting(
        "enable_checkout_sidebar_questions_block",
    );
    const preOrderPhoneNumberDisplay = usePageSetting(
        "pre_order_phone_number_display",
    );
    const checkoutSidebarExtraContent = usePageSetting(
        "checkout_sidebar_extra_content",
    );
    let questionsBlock: JSX.Element | null = null;

    if (enableCheckoutSidebarQuestionsBlock) {
        questionsBlock = (
            <div className="basket-summary__help">
                <h3>
                    <SVG
                        className="basket-summary__help-icon"
                        src={iconSpeechBubblesTalk}
                        title={t`Speech Bubbles Icon`}
                    />
                    {t`Questions?`}
                </h3>
                <div className="basket-summary__text">
                    <ChatLink
                        className="basket-summary__help--link"
                        chatOfflineLink={contactURL || homeURL}
                    />
                    <span>
                        {" "}
                        {(() => {
                            const callStrong = (
                                <strong key="call">
                                    {t`Call ${preOrderPhoneNumberDisplay}`}
                                </strong>
                            );
                            const basketIdStrong = (
                                <strong key="basket">{basketId}</strong>
                            );
                            return jt`or ${callStrong} and reference ${basketIdStrong}`;
                        })()}
                    </span>
                    <br />
                </div>
            </div>
        );
    }
    return (
        <div className="basket-summary__sidebar-content">
            {questionsBlock}
            <RichText html={checkoutSidebarExtraContent || ""} />
        </div>
    );
};
